module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper'],
    style: _vm.dynamicWrapperStyle
  }, [(!!_vm.digitalComp.bgImg) ? _c('div', {
    staticClass: ["png-wrapper"]
  }, [_vm._t("main-bg", [_c('image', {
    staticClass: ["png"],
    attrs: {
      "src": _vm.digitalComp.bgImg
    }
  })])], 2) : _vm._e(), _c('div', {
    staticClass: ["custorm-animate-wrapper"]
  }, [_vm._t("custorm-animate")], 2), _vm._t("main-lottie", [(!!_vm.lottieComp[0].data) ? _c('midea-lottie-view', {
    staticClass: ["lottie"],
    style: {
      width: _vm.lottieComp[0].width,
      height: _vm.lottieComp[0].height
    },
    attrs: {
      "data": _vm.lottieComp[0].data,
      "loop": _vm.lottieComp[0].loop
    }
  }) : _vm._e()]), _c('div', {
    staticClass: ["digital-wrapper"],
    style: _vm.digitalStyleComp
  }, [_c('div', {
    staticClass: ["digital"]
  }, [_c('div', {
    staticClass: ["top-title"]
  }, [_c('text', {
    staticClass: ["top-title-text"],
    style: _vm.textColorCalc(_vm.digitalComp)
  }, [_vm._v(_vm._s(_vm.digitalComp.title))])]), _c('div', {
    staticClass: ["main-title"]
  }, [_c('div', {
    staticClass: ["main-title-value"]
  }, [_c('div', {
    staticClass: ["main-title-unit"]
  }, [_c('text', {
    style: _vm.textColorCalc(_vm.digitalComp)
  }, [_vm._v(_vm._s(_vm.digitalComp.unit))])]), _c('text', {
    class: ['main-title-value-text', _vm.dynamicStateTextSize],
    style: _vm.textColorCalc(_vm.digitalComp)
  }, [_vm._v(_vm._s(_vm.digitalComp.value))])])]), (!!_vm.digitalComp.desc) ? _c('div', {
    staticClass: ["desc-wrapper"]
  }, _vm._l((_vm.digitalComp.desc), function(item, index) {
    return _c('div', {
      key: index,
      class: ['desc', _vm.alignStyleCalc(index, _vm.digitalComp.desc)]
    }, [_c('div', {
      staticClass: ["desc-title"]
    }, [_c('text', {
      staticClass: ["desc-title-text"],
      style: _vm.textColorCalc(item)
    }, [_vm._v(_vm._s(item.title))])]), _c('div', {
      staticClass: ["desc-value"]
    }, [_c('text', {
      staticClass: ["desc-value-text"],
      style: _vm.textColorCalc(item)
    }, [_vm._v(_vm._s(item.value))])]), (index < _vm.digitalComp.desc.length - 1) ? _c('div', {
      staticClass: ["desc-item-split-line"]
    }) : _vm._e()])
  })) : _vm._e()])]), _vm._t("stuas-bar", [_c('div', {
    staticClass: ["status-bar-wrapper"]
  }, [_vm._t("second-lottie", [(_vm.lottieComp[1] && !!_vm.lottieComp[1].data) ? _c('midea-lottie-view', {
    staticClass: ["second-lottie"],
    style: {
      width: _vm.lottieComp[1].width,
      height: _vm.lottieComp[1].height
    },
    attrs: {
      "data": _vm.lottieComp[1].data,
      "loop": _vm.lottieComp[1].loop
    }
  }) : _vm._e()]), (_vm.state !== 'offline') ? _c('div', {
    staticClass: ["status-bar"]
  }, [_c('div', {
    class: ['status-bar-title'],
    style: {
      backgroundColor: _vm.StatusBarBgColorCalc(_vm.digitalComp)
    }
  }, [_c('text', {
    staticClass: ["status-bar-title-text"]
  }, [_vm._v(_vm._s(_vm.digitalComp.status))])])]) : _vm._e()], 2)])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-23dbdeac!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-digital-panel/index.vue
// module id = 593
// module chunks = 0 1